export enum BlueprintTypes {
  Consolidated = 'consolidated',
  MultiTenant = 'multiTenant',
  Custom = 'custom',
}

export interface HostNetworkConfiguration {
  id: string
  name: string
  mgmtInterface: string
  vmConsoleInterface: string
  hostLivenessInterface: string
  tunnelingInterface: string
  imagelibInterface: string
  networkLabels: NetworkLabels
  clusterName: string
}

export interface NetworkLabels {
  [key: string]: string
}

export interface VirtualNetworkingConfig {
  enabled: boolean
  underlayType: string
  /** String range in the form "start:end", e.g. "3000:3020" */
  vnidRange: string
}

export interface StorageBackendDriverConfig {
  // Arbitrary key/value configuration; backend defines the actual keys
  [key: string]: string | number | boolean
}

export interface StorageBackendDefinition {
  config: StorageBackendDriverConfig
  driver: string
}

// storageBackends[volumeType][backendName] -> backend definition
export interface StorageBackends {
  [volumeType: string]: {
    [backendName: string]: StorageBackendDefinition
  }
}

export interface Blueprint {
  name: string
  networkingType: string
  enableDistributedRouting: boolean
  dnsDomainName: string
  virtualNetworking: VirtualNetworkingConfig
  imageLibraryStorage: string
  imageLibrarySharedStorage: boolean
  instanceSharedStorage: boolean
  vncFloatingIp: string | null
  vmStorage: string
  storageBackends: StorageBackends
}
